/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import Media from 'react-media';
import { compose } from 'recompose';

import withPageView from '../../../../helpers/tracking/hocs/withPageView';
import DesktopProfileAndPassword from './DesktopProfileAndPassword/DesktopProfileAndPassword';
import ChangeEmail from '../ChangeEmail/ChangeEmail';
import ChangePassword from '../ChangePassword/ChangePassword';
import CUSTOM_BREAKPOINTS from '../../../../helpers/customBreakpoints';
import { trackPage } from '../../../../helpers/tracking/common/commonTrackingHelpers';
import GraphqlSeoHeadTags from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const ProfileAndPassword = () => {

    const breakpointExpr = `(min-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    }, []);
    return (
        <>
            <GraphqlSeoHeadTags seoData={{
                page_title: 'My Account',
                location: { pathname: '/account/profile' },
            }}
            />
            <Media query={breakpointExpr}>
                {(matches) => (
                    matches ? (
                        <DesktopProfileAndPassword />
                    ) : (
                        <div className="padding-bottom-2x">
                            <ChangeEmail disablePageView />
                            <div className="padding-top-2x">
                                <ChangePassword noBackButton disablePageView />
                            </div>
                        </div>
                    ))}
            </Media>
        </>
    )
}

const enhance = compose(
    trackPage({
        type: 'accountprofile',
        name: 'MyAccount',
        accountPage: true,
    }),
    withPageView({
        pageViewSuccessTest: () => true,
    }),
);
export default enhance(ProfileAndPassword);
